import * as React from 'react';
import cx from 'clsx';

import { IPageContainerProps, connectWithPage } from '@montana/containers/page';
import { DynamicErrorHandler } from '@montana/shared/dynamic-error-handler';

import { error } from '@montana/services/logger';
import { FrontPage } from '@montana/pages/front-page';
import { StandardPage } from '@montana/pages/standard-page.component';
import { LoginPage } from '@montana/pages/login-page';
import { BillingPage } from '@montana/pages/checkout/billing/billing-page.component';
import { ReceiptPage } from '@montana/pages/checkout/receipt';
import { FilterPage as ProductFilterPage } from '@montana/pages/filter-page/filter-page.component';
import { CustomerInformationPage } from '@montana/pages/checkout-b2c';
import { ShippingInformationPage } from '@montana/pages/checkout-b2c/shipping-information-page';
import { ConfirmationPage } from '@montana/pages/checkout-b2c/confirmation-page';
import { ProductPage } from '@montana/pages/product-page/product-page.component';
import { CartPage } from '@montana/pages/cart-page/cart-page.component';
import { StoreLocatorPage } from '@montana/pages/store-locator-page/store-locator-page.component';
import { TermsAndConditionsPage } from './terms-and-conditions-page.component';
import { LoadingPage } from './loading-page.component';
import { ColorMaterialPage } from './color-material-page/color-material-page.component';
import { useZendeskChat } from '@montana/shared/use-zendesk-chat/use-zendesk-chat.hook';
import {ColourPage} from "@montana/pages/colour-page/colour-page.component";
import {StaticProductPage} from "@montana/pages/static-product-page/static-product-page.component";
import {SeriePage} from "@montana/pages/serie-page/serie-page.component";
import {ArticlePage} from "@montana/pages/article-page/article-page.component";


export const AuthErrorKind = 'NoAuthError';
export const CartPageKind = 'CartPage';
export const CategoryProductFilterPageKind = 'CategoryProductFilterPage';
export const ConfirmationPageKind = 'ConfirmationPage';
export const ErrorPageKind = 'ErrorPage';
export const LoadingPageKind = 'LoadingPage';
export const LoginPageKind = 'LoginPage';
export const ProductFilterPageKind = 'ProductFilterPage';
export const ProductPageKind = 'ProductPage';
export const ReceiptPageKind = 'ReceiptPage';
export const StoreLocatorPageKind = 'StoreLocatorPage';
export const ShippingPageKind = 'ShippingPage';
export const CheckoutB2CPageKind = 'CheckoutB2CPage';
export const CheckoutPageKind = 'CheckoutPage';
export const ColorMaterialPageKind = 'ColorMaterialDescriptionPage';
export const ColourPageKind = 'ColorContentPage';
export const StaticProductPageKind = 'StaticProductPage';
export const SeriesContentPageKind = 'SeriesContentPage';
export const ArticleContentPageKind = 'ArticleContentPage';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PAGES: { [key: string]: React.ComponentType<any> } = {
    NotFoundPage: StandardPage,
    FrontPage,
    ContentPage: StandardPage,
    [CheckoutPageKind]: BillingPage,
    [ReceiptPageKind]: ReceiptPage,
    [ProductFilterPageKind]: ProductFilterPage,
    [CategoryProductFilterPageKind]: ProductFilterPage,
    [ErrorPageKind]: StandardPage,
    [LoginPageKind]: LoginPage,
    [CartPageKind]: CartPage,
    [StoreLocatorPageKind]: StoreLocatorPage,
    [CheckoutB2CPageKind]: CustomerInformationPage,
    [ShippingPageKind]: ShippingInformationPage,
    [ProductPageKind]: ProductPage,
    TermsOfUsePage: TermsAndConditionsPage,
    PrivacyPolicyPage: TermsAndConditionsPage,
    [ConfirmationPageKind]: ConfirmationPage,
    [LoadingPageKind]: LoadingPage,
    [ColorMaterialPageKind]: ColorMaterialPage,
    [ColourPageKind]: ColourPage,
    [StaticProductPageKind]: StaticProductPage,
    [SeriesContentPageKind]: SeriePage,
    [ArticleContentPageKind]: ArticlePage,
};

export const DynamicPageComponent: React.FC<IPageContainerProps> = React.memo((props: IPageContainerProps): JSX.Element | null => {

    if (!props.kind || props.kind === AuthErrorKind) {
        return null;
    }

    const Page = PAGES[props.kind];

    if (Page === undefined) {
        error(`Could not find page of type ${props.kind}`);
    }

    useZendeskChat(props);

    return (
        <DynamicErrorHandler {...props}>
            <div className={cx('page-container', props.kind, { 'page-container--no-hero': props.kind === LoginPageKind })}>
                <Page {...props} />
            </div>
        </DynamicErrorHandler>
    );
}, (): boolean => true);

// @ts-ignore
export const DynamicPage = connectWithPage(DynamicPageComponent);
